<!-- 评论删除复制投诉弹出框 -->
<template>
  <div class="action-sheet">
    <van-action-sheet v-model="show">
      <div class="content">
        <div
          class="copy-btn"
          :data-clipboard-text="val.content"
          data-clipboard-action="copy"
          @click="onSelect({ name: '复制' })"
        >
          复制
        </div>
        <div
          class="van-hairline--top"
          v-for="(item, index) in action_list"
          :key="index"
          @click="onSelect(item)"
        >
          {{ item.name }}
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import clipboard from "clipboard";
new clipboard(".copy-btn");
export default {
  name: "ActionSheet",
  props: ["val"],
  data() {
    return {
      show: false,
      actions: [
        { name: "举报", show: 1 },
        { name: "删除", show: 0 },
        { name: "取消", show: 1 }
      ]
    };
  },
  computed: {
    person() {
      return this.$store.state.personInfo;
    },
    app() {
      return this.$store.state.app;
    },
    action_list() {
      return this.actions.filter(action => action.show);
    }
  },
  methods: {
    showModel() {
      if (this.person.id == this.val.uid) {
        this.actions[0].show = 0;
        this.actions[1].show = 1;
      } else {
        this.actions[0].show = 1;
        this.actions[1].show = 0;
      }
      this.show = true;
    },
    onSelect(item) {
      switch (item.name) {
        case "复制":
          this.$toast("复制成功");
          break;
        case "举报":
          if (this.val.type == 1 && this.app) {
            // app课程详情内置评论
            this.$pub.appJump(`/tip?type=${this.val.type}&id=${this.val.id}`);
          } else {
            this.$router.push({
              name: "Tip",
              query: {
                type: this.val.type,
                id: this.val.id
              }
            });
          }
          break;
        case "删除":
          this.$dialog
            .confirm({
              title: "提示",
              message: "删除后，该内容将不再展示，是否确认？"
            })
            .then(() => {
              this.submit();
            })
            .catch(() => {});
          break;
      }
      this.show = false;
    },
    submit() {
      this.$emit("deleteComment", this.val.id);
    }
  }
};
</script>

<style lang="scss" scoped>
.action-sheet {
  /deep/ .van-action-sheet {
    border-radius: 0;
  }
  .content {
    display: flex;
    flex-direction: column;
    background: #d9d9d9;
    > div {
      width: 100%;
      height: 102px;
      background: rgba(252, 252, 252, 1);
      font-size: 32px;
      font-family: PingFang SC;
      font-weight: 400;
      color: rgba(41, 41, 41, 1);
      line-height: 102px;
      text-align: center;
      &:last-child {
        margin-top: 10px;
      }
    }
  }
}
</style>
